// extracted by mini-css-extract-plugin
export var legendIndicator = "_et-1";
export var legendRight = "_et-0";